import {
  CREATE_NEW_USER_Signup,
  LOGIN_USER,
  ChangePassword,
  FOREGT_PASSWORD,
  GET_USER_PROFULE,
  UPDATE_USER_PROFULE,
  
} from "../type";

const inital = {
  createUser: [],
  loginUser: [],
  forgetPassword: [],
  userProfile: [],
  userChangePassword: [],
  updateuserProfile: [],
  loading: true,
  error: [],
};
const authReducer = (state = inital, action) => {
  switch (action.type) {
    case CREATE_NEW_USER_Signup:
      return {
        ...state,
        createUser: action.payload,
      };
    case LOGIN_USER:
      return {
        ...state,
        loginUser: action.payload,
      };
    case FOREGT_PASSWORD:
      return {
        ...state,
        forgetPassword: action.payload,
      };
    case ChangePassword:
      return {
        ...state,
        userChangePassword: action.payload,
      };
    case GET_USER_PROFULE:
      return {
        ...state,
        userProfile: action.payload,
      };
    case UPDATE_USER_PROFULE:
      return {
        ...state,
        updateuserProfile: action.payload,
      };
    // case ERROR:
    //   return {
    //     loading: false,
    //     error: action.payload,
    //   };
    default:
      return state;
  }
};
export default authReducer;
